import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {ComponentsV1Module} from '@gatewee/components/v1';
import {
  ComponentsV2Module,
  GateweeBulkConfirmDialogComponent,
} from '@gatewee/components/v2';
import {TranslateModule} from '@ngx-translate/core';
import {FileUploadComponent} from '../../../elements/file-upload/file-upload.component';
import {ProgressbarStepperComponent} from '../../../elements/progressbar-stepper/progressbar-stepper.component';
import {AddressFormComponent} from './address-form/address-form.component';
import {BusinessFormComponent} from './business-form/business-form.component';
import {BusinessProfileFormComponent} from './business-profile-form/business-profile-form.component';
import {DocumentsFormComponent} from './documents-form/documents-form.component';
import {EstimatedVolumesFormComponent} from './estimated-volumes-form/estimated-volumes-form.component';
import {LeadFormComponent} from './lead-form/lead-form.component';
import {OnboardingComponent} from './onboarding.component';
import {PartnerFormComponent} from './partners-form/partner-form/partner-form.component';
import {PartnersFormComponent} from './partners-form/partners-form.component';
import {UtilsModule} from '@gatewee/utils';

@NgModule({
  declarations: [
    OnboardingComponent,
    LeadFormComponent,
    BusinessFormComponent,
    AddressFormComponent,
    EstimatedVolumesFormComponent,
    BusinessProfileFormComponent,
    FileUploadComponent,
    DocumentsFormComponent,
    PartnersFormComponent,
    PartnerFormComponent,
    ProgressbarStepperComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ComponentsV1Module,
    ComponentsV2Module,
    UtilsModule,
    TranslateModule.forChild(),
    GateweeBulkConfirmDialogComponent,
  ],
  exports: [FileUploadComponent],
})
export class OnboardingModule {}
